export const reportInvoiceRelationshipTypes = {
  GET_REPORT_INVOICE_RELATIONSHIP: 'GET_REPORT_INVOICE_RELATIONSHIP',
  SET_REPORT_INVOICE_RELATIONSHIP_FILTERS: 'SET_REPORT_INVOICE_RELATIONSHIP_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};
